'use client';

import React, { useState } from 'react'
import Image from "next/image";
import one from '../../public/images/theme/temp1.webp'
import two from '../../public/images/theme/temp2.webp'
import three from '../../public/images/theme/temp3.webp'
import four from '../../public/images/theme/temp4.webp'
import five from '../../public/images/theme/temp5.webp'
import six from '../../public/images/theme/temp6.webp'
import seven from '../../public/images/theme/temp7.webp'
import eight from '../../public/images/theme/temp8.webp'
import close from '../../public/images/x.svg'
import logo from '../../public/images/logo.webp'
import Link from 'next/link';

export const ChooseTheamePage = () => {


  const [activeCard, setActiveCard] = useState(null);

  // Handler for card click
  const handleCardClick = (index:any) => {
    setActiveCard(index);
  };


  const [themeId, setThemeId] = useState(() => {
    // Retrieve stored theme_id from localStorage (guarded — runs during render, incl. SSR)
    if (typeof window === "undefined") return null;
    const savedData = JSON.parse(localStorage.getItem("theameId") || "{}");
    return savedData.theme_id || null;
  });

  const onThemeSelect = (selectedThemeId:any) => {
    setThemeId(selectedThemeId);

    // Update formData in localStorage
    const updatedFormData = { theme_id: selectedThemeId };
    localStorage.setItem("theameId", JSON.stringify(updatedFormData));

    console.log("Selected Theme ID:", selectedThemeId);
  };


  return (
    <div className=''>

      <section className='bg-gray-300 sm:p-5 p-0  w-full flex justify-center items-center h-[100vh]'>

      <div className=" ">
    
          <div className="flex justify-center flex-col items-center ">
            <div className="bg-white sm:rounded-2xl rounded-0 sm:py-5 py-0 relative sm:h-[614px] h-[100vh]"><div className='block sm:hidden mt-[16px]'>
        <div className=' justify-center flex'>
         <Image alt="Vilva Business logo" className='cursor-pointer' src={logo}/>
        </div>
      </div>
              <div className="p-4 flex justify-between mx-3 items-center  pt-[30px] sm:pt-[0px]">
                <div>
                <p className="text-md md:text-2xl font-semibold whitespace-nowrap !text-[#090D28]">Select Your Theme </p>
                <p className="text-[8px] md:text-sm whitespace-nowrap !text-[#090D28]">Select your perfect template and build website</p>
                </div>
                <div className='bg-[#EBEBEB] hidden sm:block rounded-md p-1'>
                 <Link href='/' aria-label="Go to Vilva Business homepage"><Image alt="Close and return to homepage" className='cursor-pointer' src={close}/></Link>
                </div>
              </div>

              <div className="px-4 mx-auto sm:py-4 py-0 relative">
              <div className="grid max-w-md grid-cols-2 gap-x-2 gap-y-2 mx-auto lg:max-w-full md:grid-cols-4 lg:grid-cols-4 h-[65vh] !overflow-x-hidden !overflow-y-auto">
              {[
                { src: one, theme_id: 1 },
                { src: two, theme_id: 2 },
                { src: three, theme_id: 3 },
                { src: four, theme_id: 4 },
                { src: five, theme_id: 5 },
                { src: six, theme_id: 6 },
                { src: seven, theme_id: 7 },
                { src: eight, theme_id: 8 },
                { src: one, theme_id: 9 },
                { src: two, theme_id: 10 },
                { src: three, theme_id: 11 },
                { src: four, theme_id: 12 },
              ].map(({ src, theme_id }) => (
                <div key={theme_id}>
                  <div
                    className={`card  overflow-hidden rounded-[10px] shadow-sm transition-all duration-300 ease-in-out
                      ${themeId === theme_id 
                        ? "border-2 rounded-[10px]  overflow-hidden !border-[#217DF8] " 
                        : "border-2   rounded-[10px]   border-transparent"}
                      hover:shadow-lg hover:scale-[1.005] cursor-pointer`}
                    onClick={() => onThemeSelect(theme_id)}
                  >
                    <Image alt={`Website theme option ${theme_id}`} src={src} className="img-fluid rounded-[10px]" />
                  </div>
                </div>
              ))}
            </div>
                <Link href="/chooseplan">
                <div className='w-full md:w-fit px-5 absolute bottom-6 right-0 md:right-6 flex justify-end'>
                <button className={`bg-[#217DF8] px-6 py-2 w-full md:w-[200px] rounded text-white cursor-pointer
                      ${themeId === null ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={themeId === null}
                  >
                    Continue
                  </button>
                </div>
              </Link>
              </div>
              


            </div>
            
          </div>
          <div className='block sm:hidden '>
        <div className=' justify-center flex fixed bottom-0 w-full mx-auto pb-[16px]'>
         <p className='text-[10px] whitespace-nowrap !text-[#090D28]'>© Copyright 2025 <a target='_blank' className='text-[#1672F1]' href="https://www.vilvabusiness.com/">Vilva Business </a>All Rights Reserved</p>
        </div>
      </div>
      </div>

      </section>

    </div>
  )
}
